<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    // token过期处理
    this.$axios.interceptors.response.use(undefined, (err) => new Promise((resolve, reject) => {
      if (err.response.status === 401) {
        console.warn(err, err.response.data);
        this.$store.dispatch('tokenInvalid');
        this.$router.push({ name: 'login' }, () => { });
        // 401 不报错直接跳转
        // eslint-disable-next-line no-promise-executor-return
        return new Promise(() => { });
      }
      console.log(err, err.response.data);
      if (err.response.data.msg) {
        this.$message.error(err.response.data.msg);
      }

      reject(err);
    }));

    this.$axios.interceptors.request.use(config => {
      // eslint-disable-next-line no-param-reassign
      config.headers['X-WorkUnit-Id'] = this.$store.state.currentWorkUnitId;
      return config;
    });

    // 刷新更新 workUnits
    if (this.$store.state.login.status === 'success') {
      this.$store.dispatch('getWorkUnits');
    }
  },
};

</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
